import React, { useState, useEffect } from 'react';
import '@assets/css/common/style_main.css';
import '@assets/css/common/style_table.css';
import '@assets/css/common/style_modal.css';
import PaginationZeroBased from '@components/common/PaginationZeroBased';

function ErrorLog() {
  const [isLoading, setIsLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [filterType, setFilterType] = useState('latest');
  const [showTroubleshootingModal, setShowTroubleshootingModal] = useState(false);
  const [currentError, setCurrentError] = useState({
    code: '',
    message: ''
  });
  
  // 삭제 관련 상태 추가
  const [errorLogs, setErrorLogs] = useState([
    { id: 1, code: '000001', message: '카메라 연결 오류', page: '사진촬영', time: '20250317 / 14:30' },
    { id: 2, code: '000001', message: '카메라 연결 오류', page: '동영상촬영', time: '20250315 / 18:30' }
  ]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [confirmCallback, setConfirmCallback] = useState(null);
  const [currentErrorLog, setCurrentErrorLog] = useState(null);
  
  // 페이지네이션 상태 관리
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrevious, setHasPrevious] = useState(false);

  // 체크박스 전체 선택/해제 핸들러
  const handleSelectAll = (e) => {
    setSelectAll(e.target.checked);
    // 실제로는 데이터에 맞게 처리 필요
    setSelectedItems(e.target.checked ? errorLogs.map(log => log.id) : []);
  };

  // 개별 체크박스 핸들러
  const handleItemSelect = (id, e) => {
    if (e.target.checked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter(item => item !== id));
    }
  };

  // 필터 변경 핸들러
  const handleFilterChange = (e) => {
    setFilterType(e.target.value);
  };

  // 일괄 삭제 핸들러
  const handleBulkDelete = () => {
    if (selectedItems.length === 0) return;
    
    setConfirmMessage(`선택한 ${selectedItems.length}개의 오류로그를 삭제하시겠습니까?`);
    setConfirmCallback(() => () => {
      setErrorLogs(errorLogs.filter(log => !selectedItems.includes(log.id)));
      setSelectedItems([]);
      setSelectAll(false);
      setAlertMessage('선택한 오류로그가 삭제되었습니다.');
      setShowAlertModal(true);
    });
    setShowConfirmModal(true);
  };

  // 로딩 상태 변경시 페이지 로더 표시 처리
  useEffect(() => {
    const pageLoader = document.querySelector('.page-loader');
    if (pageLoader) {
      if (isLoading) {
        pageLoader.classList.add('active');
      } else {
        pageLoader.classList.remove('active');
      }
    }
  }, [isLoading]);

  // 문서 버튼 클릭 핸들러
  const handleDocumentClick = (code, message) => {
    // 모달에 표시할 오류 정보 설정
    setCurrentError({
      code: code,
      message: message
    });
    
    // 트러블슈팅 가이드 모달 표시
    setShowTroubleshootingModal(true);
  };

  // 삭제 버튼 핸들러
  const handleDeleteClick = (errorLog) => {
    setCurrentErrorLog(errorLog);
    setConfirmMessage(`${errorLog.code} 오류로그를 삭제하시겠습니까?`);
    setConfirmCallback(() => () => {
      // 오류로그 삭제 로직
      setErrorLogs(errorLogs.filter(e => e.id !== errorLog.id));
      setAlertMessage('삭제되었습니다.');
      setShowAlertModal(true);
    });
    setShowConfirmModal(true);
  };

  // 모달 닫기 핸들러
  const handleCloseModal = () => {
    setShowTroubleshootingModal(false);
  };
  
  // 페이지 변경 핸들러
  const handlePageChange = (newPage) => {
    setPage(newPage);
    // 실제 구현에서는 여기서 API 호출하여 새 페이지 데이터를 가져옴
  };

  return (
    <>
          {/* 오류로그 콘텐츠 시작 */}
          <div className="page-title-container">
            <h1 className="page-title">오류로그</h1>
            <div className="page-title-icon">
              
            </div>
          </div>
          
          <div className="page-container">
            
            {/* 필터 드롭다운 */}
            <div className="filter-dropdown-container-row">

                  {/* 일괄 삭제 버튼 */}
                  <div className={`bulk-delete-container ${selectedItems.length >= 2 ? 'active' : ''}`}>
                <button className="bulk-delete-btn" onClick={handleBulkDelete}>
                  일괄 삭제 ({selectedItems.length})
                </button>
              </div>

              <div className="filter-dropdown">
                <select 
                  id="error-filter"
                  value={filterType}
                  onChange={handleFilterChange}
                >
                  <option value="latest">최신순</option>
                  <option value="name">이름순</option>
                  <option value="period">사용기간순</option>
                </select>
              </div>
              </div>
              
            
          

              {/* 테마 테이블 */}
              <div className="common-table-container">
                <table className="common-table">
                  <thead>
                    <tr>
                      <th>
                        <div className="checkbox-container">
                          <input 
                            type="checkbox" 
                            id="select-all"
                            checked={selectAll}
                            onChange={handleSelectAll}
                          />
                          <label htmlFor="select-all" className="custom-checkbox"></label>
                        </div>
                      </th>
                      <th>NO</th>
                      <th>일시</th>
                      <th>발생페이지</th>
                      <th>코드</th>
                      <th>메시지</th>
                      <th>트러블슈팅 가이드</th>
                      <th>삭제</th>
                    </tr>
                  </thead>
                  <tbody>
                    {errorLogs.map((errorLog, index) => (
                      <tr key={errorLog.id}>
                        <td>
                          <div className="checkbox-container">
                            <input 
                              type="checkbox" 
                              id={`error-${errorLog.id}`}
                              checked={selectedItems.includes(errorLog.id)}
                              onChange={(e) => handleItemSelect(errorLog.id, e)}
                            />
                            <label htmlFor={`error-${errorLog.id}`} className="custom-checkbox"></label>
                          </div>
                        </td>
                        <td>{index + 1}</td>
                        <td>{errorLog.time}</td>
                        <td>{errorLog.page}</td>
                        <td>{errorLog.code}</td>
                        <td>{errorLog.message}</td>
                        <td>
                          <button 
                            className="document-btn"
                            onClick={() => handleDocumentClick(errorLog.code, errorLog.message)}
                          >
                            <i className="ri-file-text-line"></i>
                          </button>
                        </td>
                        <td>
                          <button className="delete-btn" onClick={() => handleDeleteClick(errorLog)}>
                            <i className="ri-close-line"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                    {/* 빈 행 8개 추가 - 테이블 공간 유지를 위해 */}
                    {Array(8).fill().map((_, index) => (
                      <tr key={`empty-${index}`}>
                        <td colSpan="8">&nbsp;</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
              {/* 페이지네이션 */}
              <PaginationZeroBased
                page={page}
                totalPages={totalPages}
                hasNext={hasNext}
                hasPrevious={hasPrevious}
                onPageChange={handlePageChange}
              />
            </div>
         
          {/* 오류로그 콘텐츠 끝 */}

          {/* 트러블슈팅 가이드 모달 */}
          {showTroubleshootingModal && (
            <div className="modal-overlay active" id="troubleshooting-modal">
              <div className="modal-container">
                <div className="modal-header">
                  <h3 className="modal-title">트러블슈팅 가이드</h3>
                  <button className="modal-close" onClick={handleCloseModal}>&times;</button>
                </div>
                <div className="modal-body">
                  <div className="troubleshooting-guide">
                    <h4>오류 {currentError.code} 트러블슈팅 가이드</h4>
                    <p><strong>오류 메시지:</strong> {currentError.message}</p>
                    <p><strong>조치사항</strong> </p>
                    {/* 조치사항 PDF 이미지 불러오기 추가 */}
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    className="modal-btn modal-btn-primary"
                    onClick={handleCloseModal}
                  >
                    확인
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* 삭제 확인 모달 */}
          {showConfirmModal && (
            <div className="modal-overlay active" id="confirm-modal">
              <div className="modal-container">
                <div className="modal-header">
                  <h3 className="modal-title">확인</h3>
                  <button className="modal-close" onClick={() => setShowConfirmModal(false)}>&times;</button>
                </div>
                <div className="modal-body">
                  <p>{confirmMessage}</p>
                </div>
                <div className="modal-footer">
                  <button 
                    className="modal-btn modal-btn-cancel" 
                    onClick={() => setShowConfirmModal(false)}
                  >
                    취소
                  </button>
                  <button 
                    className="modal-btn modal-btn-primary"
                    onClick={() => {
                      confirmCallback();
                      setShowConfirmModal(false);
                    }}
                  >
                    삭제
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* 알림 모달 */}
          {showAlertModal && (
            <div className="modal-overlay active" id="alert-modal">
              <div className="modal-container">
                <div className="modal-header">
                  <h3 className="modal-title">알림</h3>
                  <button className="modal-close" onClick={() => setShowAlertModal(false)}>&times;</button>
                </div>
                <div className="modal-body">
                  <p>{alertMessage}</p>
                </div>
                <div className="modal-footer">
                  <button 
                    className="modal-btn modal-btn-primary"
                    onClick={() => setShowAlertModal(false)}
                  >
                    확인
                  </button>
                </div>
              </div>
            </div>
          )}
    </>
  );
}

export default ErrorLog;
